import { render } from "./Stichwoerter.vue?vue&type=template&id=cef890e8"
import script from "./Stichwoerter.vue?vue&type=script&lang=js"
export * from "./Stichwoerter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__